var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-link',{staticStyle:{"color":"#2B5FCB"},on:{"click":_vm.editPlan}},[_vm._v("Edit plan")]),_c('b-link',{staticClass:"ml-3",staticStyle:{"color":"#2B5FCB"},on:{"click":_vm.editItems}},[_vm._v("Edit items")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }